import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface CreateProjectFromTemplateInput {
    templateId: string;
    projectName: string;
}

interface Options {
    onSuccess?: (projectId: string) => void;
}

export function useCreateProjectFromTemplateMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: CreateProjectFromTemplateInput) => {
            const res = await apiClient.createProjectFromTemplate({
                params: { templateId: input.templateId },
                body: { projectName: input.projectName },
            });
            if (res.status !== 201) {
                throw new Error("Failed to create project from template");
            }
            return res.body.projectId;
        },
        onSuccess: async (projectId) => {
            await queryClient.invalidateQueries({ queryKey: ["projects"] });
            options?.onSuccess?.(projectId);
        },
    });
}
